import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

const EmailISVService = {
  unlockFeature: (locationId: string, feature: string) =>
    requests(SERVICE_NAME.EMAIL_ISV_API).post(`blacklist-accounts/unlock`, {
      locationId,
      type: "locked_features",
      feature,
    }),

  lockFeature: (locationId: string, feature: string) =>
    requests(SERVICE_NAME.EMAIL_ISV_API).post(`blacklist-accounts/lock`, {
      locationId,
      feature,
    }),

  flushDmarc: (email: string) =>
    requests(SERVICE_NAME.EMAIL_ISV_API).post(`flush-dmarc-cache`, {
      email,
    }),

  migrateToLcEmail: (documentId: string, feature: string) =>
    requests(SERVICE_NAME.EMAIL_ISV_API).post(
      `migrate?${feature}=${documentId}`,
      {}
    ),

  setVerificationStatus: (
    email: string,
    contactId: string,
    verificationStatus: boolean
  ) =>
    requests(SERVICE_NAME.EMAIL_ISV_API).post(
      `feature/verification/verify/manual`,
      { email, contactId, verificationStatus }
    ),

  searchDomain: (target: string, domain: string, active: boolean) =>
    requests(SERVICE_NAME.EMAIL_ISV_API).post(
      `feature/domain/search?target=${target}`,
      { domain, active }
    ),
};

export default EmailISVService;
